import React from "react";
import {
    Card,
    Row,
    Col,
    Button,
    Table,
    Collapse,
  } from "antd";
import { useHistory } from "react-router-dom";
import IntlMessages from "../../../util/IntlMessages";
import PersonalTokenImg from "../../../assets/images/personalTokens2.svg";

const PersonalTokens = () => {
    const Panel = Collapse.Panel;
    const history = useHistory();
    const columns = [
        {
          title: <IntlMessages id="setup.personalTokens.col1" />,
          dataIndex: "name",
          key: "name",
          render: (text) => {
            return <span style={{ fontWeight: "500" }}>{text}</span>;
          },
        },
        {
            title: <IntlMessages id="setup.personalTokens.col2" />,
            dataIndex: "lastcharacter",
            key: "lastcharacter",
            render: (text) => {
              return <span style={{ fontWeight: "500" }}>{text}</span>;
            },
        },
        {
            title: <IntlMessages id="setup.personalTokens.col3" />,
            dataIndex: "expiry",
            key: "expiry",
            render: (text) => {
              return <span style={{ fontWeight: "500" }}>{text}</span>;
            },
        },
  ];

  const redirect = () => {
    history.push("/dashboard/setup/personaltokens/add");
  }

    return(
        <>
            <div className="gx-main-content-wrapper">
                <div>
                    <Row>
                        <Col md={10}>
                            <h1 className="">
                                <IntlMessages id="setup.personalTokensTitle" />
                            </h1>
                        </Col>
                        <Col md={14}>
                            <div style={{ textAlign: "right", marginBottom: "16px" }}>
                                <Button
                                    className="custom-btn-addbtn"
                                    type="primary"
                                    onClick={redirect}
                                >
                                    <strong>
                                    <IntlMessages id="setup.personalTokens.addTokenButton" />
                                    </strong>
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div>
                    <Card className="gx-card" title="">
                        <Collapse>
                            <Panel
                                className="custom-promolist-help"
                                showArrow={true}
                                header={
                                    <IntlMessages id="setup.personalTokens.helpDesc" />
                                }
                            >
                                <Row>
                                    <div className="billing-main">
                                        <Col className="custom-promolist-helpdesc" md={12}>
                                            <p>
                                                <IntlMessages id="setup.personalTokens.helpDescSubText1" />
                                            </p>
                                            <p>
                                                <IntlMessages id="setup.personalTokens.helpDescSubText2" />
                                            </p>
                                            <p>
                                                <IntlMessages id="setup.personalTokens.helpDescSubText3" />
                                            </p>
                                        </Col>
                                        <Col md={12}>
                                            <img src={PersonalTokenImg} alt="" />
                                        </Col>
                                    </div>
                                </Row>
                            </Panel>
                        </Collapse>
                    </Card>
                </div>
                <div>
                    <Table 
                        className="gx-table-responsive"
                        columns={columns}
                        // dataSource={}
                    />
                </div>
            </div>
        </>
    );
}

export default PersonalTokens;